import { SettingsActionTypeKeys, SettingsActionTypes,  }  from "../actions/settingsActionTypes";
import initialState from "./settingsInitialState";

export default (
  state = initialState,
  action: SettingsActionTypes
) => {
  switch (action.type) {
    case SettingsActionTypeKeys.SAVE_SETTINGS:
      return { ...state, settings: action.settings };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.ts